import { useAuthStore } from '@/stores/authStore';
import { useDisplaySettings } from '@/stores/displaySettings';

/** Browser-local choice for the last account that selected Hide. */
export function useRestingCloseCount(): boolean {
  const viewerId = useAuthStore((s) =>
    s.status === 'authenticated' ? s.user?.id ?? null : null,
  );
  return useDisplaySettings((s) => !(
    viewerId != null && s.restingCloseCountOwnerId === viewerId && s.showRestingCloseCount === false
  ));
}
